import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para personas que viven solas o parejas sin hijos?',
  a: 'Sí. Todas las recetas tienen porciones ajustables para cualquier tamaño de familia.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Por email en menos de 5 minutos después del pago. PDF listo para celular, tablet o imprimir.'
}, {
  q: '¿Los ingredientes son accesibles?',
  a: 'Todos se consiguen en el súper del barrio o el chino de la esquina. Sin ingredientes importados ni raros.'
}, {
  q: '¿Hay mensualidad?',
  a: 'No. Un pago único, acceso para siempre.'
}, {
  q: '¿Sirve si no sé cocinar mucho?',
  a: 'Sí. Paso a paso claro, tiempos reales y glosario incluido. Diseñado para personas reales, no chefs.'
}, {
  q: '¿Qué medios de pago aceptan?',
  a: 'Mercado Pago: tarjeta, débito, transferencia y efectivo. Hasta 12 cuotas.'
}];
export const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-black" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-102">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-103">
            ❓ PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-104"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-105">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border border-gray-800 rounded-xl overflow-hidden bg-gray-900" data-id="element-106">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between bg-black hover:bg-gray-900 transition-colors text-left" data-id="element-107">
                <h3 className="text-lg md:text-xl font-bold text-white pr-4" data-id="element-108">
                  {faq.q}
                </h3>
                {openIndex === i ? <Minus className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-109" /> : <Plus className="w-6 h-6 text-orange-500 flex-shrink-0" data-id="element-110" />}
              </button>

              <AnimatePresence data-id="element-111">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-112">
                    <div className="px-6 pb-5 pt-2 border-t border-gray-800" data-id="element-113">
                      <p className="text-gray-300 text-lg leading-relaxed" data-id="element-114">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};